import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const powerbuyShopServicesApi = {
  putSyncIsPublic: (id) => {
    const body = {
      id,
      page_id: '105344925152387'
    }
    return instance().put('/powerbuy/facebook-publish-pages-post/sync-is-publish', body)
  },
  getFacebookPosts: (params) => instance().get('/powerbuy/v2/facebook-post-management', { params }),
  getFacebookPostPublicItems: (id, params) =>
    instance().get(`/powerbuy/facebook-post-management/public-list/${id}`, { params })
}

export default powerbuyShopServicesApi



// WEBPACK FOOTER //
// ./src/api/powerbuy-post.js